import React from 'react';
import { ADULT_TRANSITION_LABEL, AssessmentPatientType, normalizePatientType } from './assessmentFormConfig';

interface AdultTransitionToggleProps {
  patientType: unknown;
  onChange: (patientType: AssessmentPatientType) => void;
  disabled?: boolean;
}

/** Phase 19 F26: replaces the patient-type selector; off = pediatric (default), on = adult transition patient. */
const AdultTransitionToggle: React.FC<AdultTransitionToggleProps> = ({ patientType, onChange, disabled = false }) => (
  <div className="flex items-end">
    <label className="flex items-center text-sm text-gray-600">
      <input
        type="checkbox"
        className="mr-2"
        disabled={disabled}
        checked={normalizePatientType(patientType) === 'adult'}
        onChange={(e) => onChange(e.target.checked ? 'adult' : 'pediatric')}
      />
      {ADULT_TRANSITION_LABEL}
    </label>
  </div>
);

export default AdultTransitionToggle;
